// filepath: /c:/Projetos/affiliate-web/src/App.tsx
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastProvider } from './hooks/toastContext';
import Home from './pages/Home';
import SuccessPage from './pages/Link';

function App() {
  return (
    <ToastProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;